import React from 'react';

import ReactDOM from 'react-dom';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'url-search-params-polyfill';

import { AttachmentsDialog } from '@qality/common-components';
import { AttachmentFile } from '@qality/common-model';
import { AttachmentHelper } from '@qality/common-service';
import { ServerServices } from '@qality/server-services';

export default {
  openAttachmentDialog(
    index: number,
    files: AttachmentFile[],
    isOpen: boolean
  ): void {
    ServerServices.init();
    const fileCheck = files.some((file) => {
      return file.content;
    });

    let filesForDialog = files;
    if (!fileCheck) {
      filesForDialog = AttachmentHelper.attachmentURLCreator(files);
    }
    const modalElem: HTMLElement = document.getElementById(
      'com_soldevelo_apps_test-management-modal-attachments'
    );
    ReactDOM.render(
      <AttachmentsDialog
        mediaIndex={index}
        files={filesForDialog}
        isOpen={isOpen}
        dialogClose={dialogClose}
      />,
      modalElem
    );
  },
};

function dialogClose() {
  const remove: HTMLElement = document.querySelector(
    '#com_soldevelo_apps_test-management-modal-attachments'
  );
  ReactDOM.unmountComponentAtNode(remove);
}
